import {
  SHREDDED_EXCLUDED_FLOW_IDS,
  SHREDDED_RELAUNCH_FLAG,
} from "libs/recipes/src/lib/recipes";

import useFeatureFlag from "./useFeatureFlag";

interface IUseIsShreddedEnabledProps {
  formName?: string;
}

export const useIsShreddedEnabled = (
  { formName }: IUseIsShreddedEnabledProps = {},
): boolean => {
  const { isFeatureFlagActive } = useFeatureFlag({
    featureFlagId: SHREDDED_RELAUNCH_FLAG,
    featureFlagValue: "test",
  });

  if (SHREDDED_EXCLUDED_FLOW_IDS.has(formName ?? "")) {
    return false;
  }

  return isFeatureFlagActive;
};
